<div style="display: flex; flex-direction: column; gap: 10px; justify-content: space-between; align-items: center;">
    <input #fileCtrl hidden type="file" [multiple]="allowMultiple" id="fileSelector" [accept]="accept"
        (change)="onSelectedFileChange($event)" class="file-input" />
    <div style="display: flex; justify-content: flex-end; flex-wrap: wrap; align-items: center; gap: 5px;">
        <div>
            <!-- {{fileCtrl?.files[0]?.name || "No file uploaded yet."}} -->
            @if(attachments.length > 0) {
            <span class="file-size">{{ attachments.length | number }} file(s) selected</span>

            } @else {
            <span class="file-size">No file selected</span>
            }
        </div>
        <div>
            <button mat-mini-fab color="" (click)="fileCtrl.click()">
                <mat-icon>attach_file</mat-icon>
            </button>
        </div>
    </div>

    @if(attachments.length > 0) {
    <div>
        @for (data of attachments; track data) {
        <div
            style="display: flex; justify-content: flex-end; align-items: center; flex-direction: row; flex-wrap: nowrap;">
            <mat-chip-row (removed)="removeFile(data)" class="file-chip">
                {{ shortFileNameWithExt(data) }}
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
            <span>
                @if (data.uploadError) {
                    <mat-icon color="warn">error</mat-icon>
                } @else if (data.uploadProgress < 1) { 
                    <mat-spinner [diameter]="20"></mat-spinner>
                } @else {
                    <mat-icon color="primary">check</mat-icon>
                }
            </span>
        </div>
        }
    </div>
    }
</div>